// extracted by mini-css-extract-plugin
export default {"container":"OC-z","ratingLayout":"PC-z","ratingLabel":"QC-z"};